// extracted by mini-css-extract-plugin
module.exports = {"container":"TwoTextItemToggle-module__container--otdfm","option":"TwoTextItemToggle-module__option--51alZ","selected":"TwoTextItemToggle-module__selected--1GpAt"};